import { useRef } from 'react';
import { formatPrice, convertToCents, convertFromCents } from '@helpers/utils/price-formatter-helper';

type FormatPriceReturn = {
  formatPrice: (price: number, currency: string, language: string) => string;
  convertToCents: (price: string | number) => number;
  convertFromCents: (price: string | number) => number;
};

const useFormatPrice = (): FormatPriceReturn => {
  const formatPriceRef = useRef({
    formatPrice,
    convertToCents,
    convertFromCents,
  });
  return formatPriceRef.current;
};

export default useFormatPrice;
